import React, { useState, useEffect } from 'react';
import { getCurrentUser } from 'aws-amplify/auth';
import ExamView from './ExamView';

function ExamViewWrapper({ selectedCertification, setSelectedCertification }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getUser = async () => {
      try {
        const cognitoUser = await getCurrentUser();
        setUser(cognitoUser);
      } catch {
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    getUser();
  }, []);

  if (loading) {
    return <div>ユーザー情報を読み込み中...</div>;
  }

  if (!user) {
    return <div>ログインが必要です。</div>;
  }

  return (
    <ExamView 
      selectedCertification={selectedCertification}
      setSelectedCertification={setSelectedCertification}
      user={user}
    />
  );
}

export default ExamViewWrapper;